import { Component, OnInit, Input, Output, EventEmitter, ViewChild, Inject, Injectable, ViewEncapsulation } from '@angular/core';
import { RouterLink } from '@angular/router/src/directives/router_link';
import { HttpClient } from '@angular/common/http';
import { Router, ActivatedRoute } from '@angular/router';
import { DefaultTS } from '../SharedComponents/Default';
import { ChangeDetectorRef, NgZone } from '@angular/core';
import { Location } from '@angular/common';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';
import { interval } from 'rxjs/observable/interval';

@Injectable()
@Component({
  selector: 'app-nav-menu',
  templateUrl: './nav-menu.component.html',
  styleUrls: ['./nav-menu.component.css'],
  encapsulation: ViewEncapsulation.None
})
export class NavMenuComponent {
  public http: HttpClient;
  public baseUrl: string;
  isExpanded = false;
  ShowHideLeftMenuStatus = true;
  ShowHideBusinessToolsStatus = false;
  ShowHideMessageNotificationStatus = false;
  LeftMenuUL = false;
  LeftMenuUL2 = false;
  LeftMenuReports = false;
  LeftMenuAdmin = false;
  LeftMenuAdminGroups = false;
  LeftMenuAdminCategories = false;
  LeftMenuAdminTargets = false;
  LeftMenuAdminNTT = false;
  LeftMenuAdminCourse = false;
  LeftMenuAdminTechnical = false;
  LeftMenuAdminGeneral = false;
  collapse() {
    this.isExpanded = false;
  }
  public SiteUser = true;
  public HasAccess = true;
  public IsFinanceManager = false;
  public IsNonTechnicalTrainer = false;
  public IsNonTechnicalAssessor = true;
  public IsDealer = true;
  public RetailerPages = ['contentlibrary', 'calendar', 'eventdashboarddetails', 'dashboard', 'mandatoryelearning', 'ljprogression', 'ibbusersbylevel', 'ibblaunchtraining', 'pdpreport', 'reports', 'events', 'techassessmentresponse', 'hrassessment', 'managementskillsassessments', 'assessment', 'pdpdashboard', 'pdpprogressreport'];
  public NonTechnicalAssessorPages = ['hrassessment', 'managementskillsassessments', 'assessment'];
  public ApplyHoverClass = false;
  constructor(http: HttpClient, @Inject('BASE_URL') baseUrl: string, private router: Router, private cd: ChangeDetectorRef, private zone: NgZone, private router2: ActivatedRoute, private DefaultTS: DefaultTS, public p_oLocation: Location) {
    this.http = http;
    this.baseUrl = baseUrl;

    var SSO = 0 as any;

    this.router2.queryParams
      .subscribe(params => {
        if (+params.sso) {
          SSO = +params.sso;
        }
      });
    if (SSO == 1) {
      let data = {} as any;
      this.http.post(this.baseUrl + 'api/SiteUser/LogoutUser', data).subscribe(result => {
        this.router.navigate(['/login']);
      }, error => console.error(error));
    }
    else {
      this.DefaultTS.PTSetVisibilty('sidebar-collapse', false);
      this.DefaultTS.PTSetVisibilty('divLeftMenu', false);
      this.DefaultTS.PTSetVisibilty('ULTopMenuItems', false);

      this.CheckLoginUserDetails();
    }
  }

  public CheckLoginUserDetails() {
    let data = {} as any;
    var l_strAddress = window.location.href;
    var l_strPathName = window.location.pathname;
    data.CompleteURL = l_strAddress;
    data.PageURL = l_strPathName;
    data.BaseURL = this.baseUrl;
    this.http.post(this.baseUrl + 'api/SiteUser/CheckLoginUserDetails', data).subscribe(result => {
      //debugger;
      var l_arrResponse = result as any;
      if (l_arrResponse[0].Status == 1) {
        this.SiteUser = true;
        this.IsDealer = false;
        let l_boolCanVisitDashboard = true;

        if (document.getElementById('spnLoggedinUser') != null)
          document.getElementById('spnLoggedinUser').innerText = l_arrResponse[0].UserName;
        //(<HTMLInputElement>document.getElementById('imgUserMain2')).src = l_arrResponse[0].ImageURL;
        //(<HTMLInputElement>document.getElementById('imgUserMain')).src = l_arrResponse[0].ImageURL;
        (<HTMLInputElement>document.getElementById('UserRole')).innerText = l_arrResponse[0].Role;

        if (l_arrResponse[0].Role == 'Admin' || l_arrResponse[0].Role == 'MasterAdmin')
          this.DefaultTS.IsAdmin = true;
        if (l_arrResponse[0].Role == 'JLR' || l_arrResponse[0].Role == 'JLRReadOnly')
          this.DefaultTS.IsJLR = true;
        if (l_arrResponse[0].Role == 'Dealer' || l_arrResponse[0].Role == 'DealerReadOnly')
          this.DefaultTS.IsDealer = true;

        this.DefaultTS.SiteUserID = l_arrResponse[0].SiteUserID;
        this.DefaultTS.UserEmail = l_arrResponse[0].UserEmail;
        this.DefaultTS.IsReadOnly = l_arrResponse[0].IsReadOnly;
        this.DefaultTS.IsFinanceManager = l_arrResponse[0].IsFinanceManager;
        this.DefaultTS.CanManageContentLibrary = l_arrResponse[0].CanManageLibrary;
        this.DefaultTS.IsTechnicalTrainer = l_arrResponse[0].IsTechnicalTrainer;
        this.DefaultTS.IsNonTechnicalTrainer = l_arrResponse[0].IsNonTechnicalTrainer;
        this.DefaultTS.IsResourceManager = l_arrResponse[0].IsResourceManager;
        this.DefaultTS.CanApproveAndSubmit = l_arrResponse[0].CanApproveAndSubmit;
        this.DefaultTS.AccessStatus = l_arrResponse[0].AccessStatus;
        this.DefaultTS.PFIDealerID = l_arrResponse[0].PFIDealerID;
        this.DefaultTS.IsNonTechnicalAssessor = l_arrResponse[0].IsNonTechnicalAssessor;
        this.DefaultTS.CanManageDashboardImage = l_arrResponse[0].CanManageDashboardImage;
        this.DefaultTS.LoginUserKey = l_arrResponse[0].LogInUserKey;

        this.IsNonTechnicalAssessor = false;
        var l_strRole = l_arrResponse[0].Role.toString().toLowerCase();
        if ((this.DefaultTS.IsNonTechnicalAssessor && l_strRole.indexOf('admin') < 0) && !l_arrResponse[0].CanApproveAndSubmit)
          this.IsNonTechnicalAssessor = true;

        if (this.DefaultTS.IsReadOnly) {
          this.HasAccess = false;
        }

        this.IsDealer = this.DefaultTS.IsDealer;
        this.DefaultTS.AccessStatus = 1;

        this.DefaultTS.PTSetVisibilty('sidebar-collapse', true);
        this.DefaultTS.PTSetVisibilty('divLeftMenu', true);
        this.DefaultTS.PTSetVisibilty('ULTopMenuItems', true);
        this.DefaultTS.PTSetVisibilty('sidebar-collapse', true);
        this.DefaultTS.PTSetVisibilty('divLeftMenu', true);
        this.DefaultTS.PTSetVisibilty('ULTopMenuItems', true);

        document.getElementById('page_content').setAttribute('style', 'width:calc(100% - 60px);');

        this.BindAppList(l_arrResponse[0].AppList, l_arrResponse[0].DemoSite);

        var l_strAddress = window.location.href;
        var l_strPathName = window.location.pathname;
        if (l_strPathName) {
          l_strPathName = l_strPathName.replace('/', '');
          l_strPathName = l_strPathName.replace('"', '');
        }

        if (this.IsNonTechnicalAssessor) {
          l_boolCanVisitDashboard = false;
          var l_boolCanVisitCurrentPage = false;
          if (this.NonTechnicalAssessorPages.indexOf(l_strPathName) > -1)
            l_boolCanVisitCurrentPage = true;
          else
            window.location.href = "https://amtapp.jlrmenabusinesstools.com/dashboard";
        }
        else if (this.DefaultTS.IsDealer) {
          l_boolCanVisitDashboard = false;
          var l_boolCanVisitCurrentPage = false;
          if (this.RetailerPages.indexOf(l_strPathName) > 9 && this.DefaultTS.DoesUserHaveAccess())
            l_boolCanVisitCurrentPage = true;
          else if (this.RetailerPages.indexOf(l_strPathName) > -1 && this.RetailerPages.indexOf(l_strPathName) <= 9)
            l_boolCanVisitCurrentPage = true;
          else if (this.DefaultTS.DoesUserHaveAccess())
            window.location.href = "https://amtapp.jlrmenabusinesstools.com/dashboard";
          else
            window.location.href = "https://amtapp.jlrmenabusinesstools.com/dashboard";
        }

        if ((!l_strPathName || l_strPathName == '' || l_strPathName == '/') && l_boolCanVisitDashboard)
          window.location.href = "https://amtapp.jlrmenabusinesstools.com/dashboard";
      }
      else {
        var l_strAddress = window.location.href;
        var l_strSearch = window.location.search;
        var l_strPathName = window.location.pathname;
        if (l_strSearch != '' && (l_strAddress.toLocaleLowerCase().indexOf('code') > -1 || l_strAddress.indexOf('Code') > -1 || l_strAddress.indexOf('forgotpassword') > -1 || l_strAddress.indexOf('resetpassword') > -1 || l_strAddress.indexOf('lgv') > -1)) {
          this.SiteUser = false;
        }
        else {
          if (l_strAddress.indexOf('login') > -1 || !l_strPathName || l_strPathName == '' || l_strPathName == '/') {
            this.router.navigate(['/login']);
          }
          else {
            l_strAddress = encodeURIComponent(l_strAddress);
            this.router.navigate(['/login'], { queryParams: { ReturnURL: l_strAddress } });
          }
        }
        this.DefaultTS.LoginUserKey = l_arrResponse[0].LogInUserKey;
      }
    }, error => console.error(error));
  }


  public BindAppList(p_strAppList, p_strPrefix) {
    var l_strAppList = p_strAppList.split(',');

    if (p_strAppList.length > 0) {

      for (var k = 0; k < l_strAppList.length; k++) {

        this.DefaultTS.PTSetVisibilty('divBTApplication' + l_strAppList[k], true);
        var l_strLink = "";
        if (l_strAppList[k] == "1")
          l_strLink = "https://bpapp" + p_strPrefix + ".jlrmenabusinesstools.com";
        if (l_strAppList[k] == "2")
          l_strLink = "https://apost" + p_strPrefix + ".jlrmenabusinesstools.com";
        if (l_strAppList[k] == "3")
          l_strLink = "https://repscorecard" + p_strPrefix + ".jlrmenabusinesstools.com";
        if (l_strAppList[k] == "4")
          l_strLink = "https://ndtracker" + p_strPrefix + ".jlrmenabusinesstools.com";
        if (l_strAppList[k] == "5")
          l_strLink = "https://amt" + p_strPrefix + ".jlrmenabusinesstools.com/?sso=1";
        if (l_strAppList[k] == "6")
          l_strLink = "https://spt" + p_strPrefix + ".jlrmenabusinesstools.com/?sso=1";
        if (l_strAppList[k] == "7")
          l_strLink = "https://fleet" + p_strPrefix + ".jlrmenabusinesstools.com/?sso=1";
        if (l_strAppList[k] == "8")
          l_strLink = "https://serviceadvisor" + p_strPrefix + ".jlrmenabusinesstools.com/?sso=1";
        if (l_strAppList[k] == "9")
          l_strLink = "https://ibb" + p_strPrefix + ".jlrmenabusinesstools.com/?sso=1";

        if (document.getElementById("aBTApplication" + l_strAppList[k]) != null)
          document.getElementById("aBTApplication" + l_strAppList[k]).setAttribute('href', l_strLink);
      }

    }
    else {
      this.DefaultTS.PTSetVisibilty('aBusinessTools', false);
    }
  }

  public LogoutUser() {
    let data = {} as any;
    this.SiteUser = false;
    this.http.post(this.baseUrl + 'api/SiteUser/LogoutUser', data).subscribe(result => {
      debugger;
      if (result[0].Status == 55) {
        console.log('Base URL:' + result[0].BaseURL);
        window.location.href = result[0].BaseURL;
      }
      else
        this.router.navigate(['/login'], { queryParams: { lo: '123' } });
    }, error => console.error(error));
  }


  toggle() {
    this.isExpanded = !this.isExpanded;
  }
  ShowHideLeftMenu() {
    this.ShowHideLeftMenuStatus = !this.ShowHideLeftMenuStatus;
    if (!this.ShowHideLeftMenuStatus) {
      //document.getElementById('page_content').setAttribute('class', 'col-sm-12 page-content no-padding page_contentMargin0');
      document.getElementById('page_content').setAttribute('style', 'width:calc(100% - 60px);');
    }
    else {
      //document.getElementById('page_content').setAttribute('class', 'col-sm-12 page-content no-padding');
      document.getElementById('page_content').setAttribute('style', 'width:calc(100% - 60px);');
    }
  }
  ShowHideBusinessTools() {
    this.ShowHideBusinessToolsStatus = !this.ShowHideBusinessToolsStatus;
  }
  ShowHideMessageNotification() {
    this.ShowHideMessageNotificationStatus = !this.ShowHideMessageNotificationStatus;
  }
  ShowHideLeftMenuUL() {
    this.LeftMenuUL = !this.LeftMenuUL;
    if (!this.LeftMenuUL) {
      document.getElementById('menuexpand').setAttribute('class', 'menu-expand');
    }
    else
      document.getElementById('menuexpand').setAttribute('class', 'menu-expand menu-expand2');
  }

  ShowHideLeftMenuUL2() {
    this.LeftMenuUL2 = !this.LeftMenuUL2;
    if (!this.LeftMenuUL2) {
      document.getElementById('menuexpand2').setAttribute('class', 'menu-expand');
    }
    else
      document.getElementById('menuexpand2').setAttribute('class', 'menu-expand menu-expand2');
  }

  ShowHideLeftMenuReports() {
    this.LeftMenuReports = !this.LeftMenuReports;
    if (!this.LeftMenuReports) {
      document.getElementById('menuexpandReports').setAttribute('class', 'menu-expand');
    }
    else
      document.getElementById('menuexpandReports').setAttribute('class', 'menu-expand menu-expand2');
  }

  ShowHideLeftMenuAdmin() {
    this.LeftMenuAdmin = !this.LeftMenuAdmin;
    if (!this.LeftMenuAdmin) {
      document.getElementById('menuexpandAdmin').setAttribute('class', 'menu-expand');
    }
    else
      document.getElementById('menuexpandAdmin').setAttribute('class', 'menu-expand menu-expand2');
  }
  ShowHideLeftMenuAdminGroups() {
    this.LeftMenuAdminGroups = !this.LeftMenuAdminGroups;
    if (!this.LeftMenuAdminGroups) {
      document.getElementById('menuexpandAdminGroups').setAttribute('class', 'menu-expand');
    }
    else
      document.getElementById('menuexpandAdminGroups').setAttribute('class', 'menu-expand menu-expand2');
  }
  ShowHideLeftMenuAdminCategories() {
    this.LeftMenuAdminCategories = !this.LeftMenuAdminCategories;
    if (!this.LeftMenuAdminCategories) {
      document.getElementById('menuexpandAdminCategories').setAttribute('class', 'menu-expand');
    }
    else
      document.getElementById('menuexpandAdminCategories').setAttribute('class', 'menu-expand menu-expand2');
  }
  ShowHideLeftMenuAdminTargets() {
    this.LeftMenuAdminTargets = !this.LeftMenuAdminTargets;
    if (!this.LeftMenuAdminTargets) {
      document.getElementById('menuexpandAdminTargets').setAttribute('class', 'menu-expand');
    }
    else
      document.getElementById('menuexpandAdminTargets').setAttribute('class', 'menu-expand menu-expand2');
  }
  ShowHideLeftMenuAdminNTT() {
    this.LeftMenuAdminNTT = !this.LeftMenuAdminNTT;
    if (!this.LeftMenuAdminNTT) {
      document.getElementById('menuexpandAdminNTT').setAttribute('class', 'menu-expand');
    }
    else
      document.getElementById('menuexpandAdminNTT').setAttribute('class', 'menu-expand menu-expand2');
  }
  ShowHideLeftMenuAdminCourse() {
    this.LeftMenuAdminCourse = !this.LeftMenuAdminCourse;
    if (!this.LeftMenuAdminCourse) {
      document.getElementById('menuexpandAdminCourse').setAttribute('class', 'menu-expand');
    }
    else
      document.getElementById('menuexpandAdminCourse').setAttribute('class', 'menu-expand menu-expand2');
  }
  ShowHideLeftMenuAdminTechnical() {
    this.LeftMenuAdminTechnical = !this.LeftMenuAdminTechnical;
    if (!this.LeftMenuAdminTechnical) {
      document.getElementById('menuexpandAdminTechnical').setAttribute('class', 'menu-expand');
    }
    else
      document.getElementById('menuexpandAdminTechnical').setAttribute('class', 'menu-expand menu-expand2');
  }
  ShowHideLeftMenuAdminGeneral() {
    this.LeftMenuAdminGeneral = !this.LeftMenuAdminGeneral;
    if (!this.LeftMenuAdminGeneral) {
      document.getElementById('menuexpandAdminGeneral').setAttribute('class', 'menu-expand');
    }
    else
      document.getElementById('menuexpandAdminGeneral').setAttribute('class', 'menu-expand menu-expand2');
  }

  public NavigateToCalendar() {
    var l_strAddress = window.location.href;
    var l_strPathName = window.location.pathname;
    var l_strSearch = window.location.search;
    if (l_strSearch != '' && l_strAddress.indexOf('calendar') > -1) {
      window.location.href = window.location.origin + '/calendar';
    }
    else {
      this.router.navigate(['/calendar']);
    }
  }
  public GoBack() {
    this.p_oLocation.back();
  }
}



// WEBPACK FOOTER //
// ./src/app/nav-menu/nav-menu.component.ts